export class ListAzureAppRegistrationsResponse {
    'appRegistrations';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "appRegistrations",
            "baseName": "appRegistrations",
            "type": "Array<AzureAppRegistrationOption>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureAppRegistrationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
